import { render, staticRenderFns } from "./renewRecord.vue?vue&type=template&id=4b51cd39&scoped=true"
import script from "./renewRecord.vue?vue&type=script&lang=js"
export * from "./renewRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b51cd39",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b51cd39')) {
      api.createRecord('4b51cd39', component.options)
    } else {
      api.reload('4b51cd39', component.options)
    }
    module.hot.accept("./renewRecord.vue?vue&type=template&id=4b51cd39&scoped=true", function () {
      api.rerender('4b51cd39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/station/renewRecord.vue"
export default component.exports